import script from "./AiProcessing.vue?vue&type=script&setup=true&lang=js"
export * from "./AiProcessing.vue?vue&type=script&setup=true&lang=js"

import "./AiProcessing.vue?vue&type=style&index=0&id=2103a836&lang=scss&scoped=true"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2103a836"]])

export default __exports__